// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9c6d34e145ba9b0040b1","293":"aeb3f7a954976aa678a0","518":"57d76d41f11cc3c1a9e9","779":"b76aaf32fbffa59bc621"}[chunkId] + ".js";
};